import { useMemo } from 'react';
import { SearchRequiredState } from '../components/app/components/SourceConfigWrapper';
import { useFlowState } from '@getvim/flow-context-provider/build';
import { DatasourceTheme } from '../components/app/types/datasourceConfig';

export const useDatasourceTheme = (source: string | undefined): DatasourceTheme | undefined => {
  const { datasourcesConfig } = useFlowState<SearchRequiredState>();

  return useMemo(() => {
    return datasourcesConfig?.find((datasource) => datasource.dataSourceEnum === source)?.title;
  }, [datasourcesConfig, source]);
};
